// The 8 W8ED pillars. TIME is not a pillar — it is the dimension they compound through.
export const PILLARS = [
  {
    id: "nutrition",
    number: "01",
    name: "NUTRITION",
    status: "LIVE",
    short: "Food is information, fuel and material.",
    long: "Nutrition encompasses food quality, protein, fibre, energy, micronutrients, eating behaviour, food environment, metabolic response, meal composition and nutrient density. Nutrition is not simply calories or dieting — it is one part of a larger biological system.",
    why: "Eating is the most repeated health behaviour most people have. Repeated three times a day, every day, for decades — small nutritional signals become large biological outcomes.",
    related: ["metabolism", "muscle", "recovery", "behaviour"],
    perspective: "W8ED treats nutrition as an entry point into the system — not a category on its own.",
    research: "RESEARCH COMING SOON",
    thinking: ["what-your-food-is-really-telling-your-body"],
    programmes: ["w8ed-nutrition"],
    products: ["protein", "fibre", "functional-foods"],
  },
  {
    id: "metabolism",
    number: "02",
    name: "METABOLISM",
    status: "LIVE",
    short: "The engine.",
    long: "Metabolism encompasses energy production, energy expenditure, glucose regulation, insulin, metabolic flexibility, fuel utilisation and adaptation. It is the engine that converts inputs into capacity.",
    why: "Metabolic health sits underneath energy, weight, performance and long-term disease risk — yet it is usually reduced to a number on a scale.",
    related: ["nutrition", "muscle", "movement", "sleep", "stress", "recovery"],
    perspective: "W8ED avoids oversimplified metabolic claims. The engine responds to the whole system, not to single hacks.",
    research: "RESEARCH COMING SOON",
    thinking: ["the-body-is-a-system"],
    programmes: ["w8ed-metabolic"],
    products: ["functional-foods", "functional-beverages"],
  },
  {
    id: "muscle",
    number: "03",
    name: "MUSCLE",
    status: "LIVE",
    short: "More than appearance.",
    long: "Muscle contributes to strength, lean mass, metabolic capacity, physical resilience, performance, healthy ageing, recovery and independence. It is tissue, organ and insurance policy at once.",
    why: "Muscle is one of the strongest predictors of how well people age — yet it is treated as aesthetic rather than structural.",
    related: ["nutrition", "metabolism", "movement", "recovery"],
    perspective: "W8ED treats muscle as infrastructure for metabolism, movement and independence across a lifetime.",
    research: "RESEARCH COMING SOON",
    thinking: ["why-muscle-matters"],
    programmes: ["w8ed-performance"],
    products: ["protein", "performance-nutrition"],
  },
  {
    id: "movement",
    number: "04",
    name: "MOVEMENT",
    status: "LIVE",
    short: "Physical capacity in action.",
    long: "Movement includes exercise, daily movement, mobility, strength, cardiorespiratory fitness, physical capacity, training and activity. Everyday movement and structured exercise are related — but not the same signal.",
    why: "The body adapts to what it repeatedly does — or repeatedly doesn't do. Movement is the clearest daily vote for future capacity.",
    related: ["muscle", "metabolism", "sleep", "stress", "recovery"],
    perspective: "W8ED separates movement from exercise culture: capacity first, aesthetics as a side effect.",
    research: "RESEARCH COMING SOON",
    thinking: ["you-are-what-you-repeat"],
    programmes: ["w8ed-performance"],
    products: ["performance-nutrition"],
  },
  {
    id: "sleep",
    number: "05",
    name: "SLEEP",
    status: "LIVE",
    short: "Not simply downtime.",
    long: "Sleep encompasses sleep quality, sleep duration, circadian rhythm, recovery, performance, metabolic health and behaviour. It is an active biological process, not an absence of one.",
    why: "Sleep touches nearly every other pillar — appetite, stress, recovery, performance and the decisions made the next day.",
    related: ["stress", "recovery", "metabolism", "behaviour"],
    perspective: "W8ED treats sleep as infrastructure, not a luxury.",
    research: "RESEARCH COMING SOON",
    thinking: ["time-changes-everything"],
    programmes: ["w8ed-longevity"],
    products: ["daily-health"],
  },
  {
    id: "stress",
    number: "06",
    name: "STRESS",
    status: "LIVE",
    short: "A biological signal.",
    long: "Stress includes acute stress, chronic stress, adaptation, environment, behaviour, recovery and load. Stress is not simply bad — it is a signal the system responds and adapts to, for better or worse.",
    why: "The same signal that builds capacity in the right dose erodes it in the wrong one. Dose, recovery and context decide which.",
    related: ["sleep", "recovery", "behaviour", "movement", "metabolism"],
    perspective: "W8ED frames stress as load to be managed and adapted to — not an enemy to be eliminated.",
    research: "RESEARCH COMING SOON",
    thinking: ["youre-not-lazy"],
    programmes: ["w8ed-performance"],
    products: ["daily-health"],
  },
  {
    id: "recovery",
    number: "07",
    name: "RECOVERY",
    status: "LIVE",
    short: "Where adaptation happens.",
    long: "Recovery includes sleep, rest, nutrition, load management, adaptation and restoration. Adaptation does not happen only during effort — it happens when the system is allowed to respond to it.",
    why: "Recovery is part of performance, not the opposite of it. Without it, inputs accumulate as damage instead of adaptation.",
    related: ["sleep", "nutrition", "muscle", "movement", "stress"],
    perspective: "W8ED builds recovery into the system rather than treating it as an afterthought.",
    research: "RESEARCH COMING SOON",
    thinking: ["health-is-compound-interest"],
    programmes: ["w8ed-longevity"],
    products: ["performance-nutrition", "daily-health"],
  },
  {
    id: "behaviour",
    number: "08",
    name: "BEHAVIOUR",
    status: "LIVE",
    short: "What you actually repeat.",
    long: "Behaviour includes habits, environment, decision making, friction, reward, consistency, discipline and repetition. Knowledge does not automatically create action — systems do.",
    why: "Every other pillar only matters if it is repeated. Behaviour is where science either becomes a life — or stays information.",
    related: ["nutrition", "sleep", "stress", "movement"],
    perspective: "This pillar connects directly to DISCIPLINE > DOPAMINE. Discipline is not punishment — it is repeatedly choosing a future outcome over an immediate reward. Dopamine is not the enemy; imbalance is.",
    research: "RESEARCH COMING SOON",
    thinking: ["discipline-over-dopamine", "you-are-what-you-repeat", "youre-not-lazy"],
    programmes: ["w8ed-nutrition"],
    products: [],
  },
];

export const pillarById = (id) => PILLARS.find((p) => p.id === id);
